function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('papaparse'), require('lodash/isFunction'), require('famulus/isValuesUnique')) : typeof define === 'function' && define.amd ? define(['papaparse', 'lodash/isFunction', 'famulus/isValuesUnique'], factory) : global.myBundle = factory(global.Papa, global._isFunction, global.isValuesUnique);
})(this, function (Papa, _isFunction, isValuesUnique) {
  'use strict';

  Papa = Papa && Papa.hasOwnProperty('default') ? Papa['default'] : Papa;
  isValuesUnique = isValuesUnique && isValuesUnique.hasOwnProperty('default') ? isValuesUnique['default'] : isValuesUnique;
  _isFunction = _isFunction && _isFunction.hasOwnProperty('default') ? _isFunction['default'] : _isFunction;
  /**
   * @param {File} csvFile
   * @param {Object} config
   */

  function CSVFileValidator(csvFile, config) {
    return new Promise(function (resolve, reject) {
      if (!config || config && !config.headers) {
        return resolve({
          inValidData: [{
            message: 'config headers are required'
          }],
          data: []
        });
      }

      Papa.parse(csvFile, _objectSpread(_objectSpread({}, config.parserConfig), {}, {
        skipEmptyLines: true,
        complete: function complete(results) {
          resolve(_prepareDataAndValidateFile(results.data, config));
        },
        error: function error(_error, file) {
          reject({
            error: _error,
            file: file
          });
        }
      }));
    });
  }
  /**
   * @param {Array} csvData
   * @param {Object} config
   * @private
   */


  function _prepareDataAndValidateFile(csvData, config) {
    var file = {
      inValidData: [],
      data: []
    };
    csvData.forEach(function (row, rowIndex) {
      var columnData = {}; // fields are mismatch

      if (rowIndex !== 0 && row.length !== config.headers.length) {
        file.inValidData.push({
          rowIndex: rowIndex,
          message: 'Number of fields mismatch: expected ' + config.headers.length + ' fields' + ' but parsed ' + row.length + '. In the row ' + rowIndex
        });
      }

      row.forEach(function (columnValue, columnIndex) {
        var valueConfig = config.headers[columnIndex];
        columnValue = _clearValue(columnValue);

        if (!valueConfig) {
          return;
        } // header validation, skip if isHeaderNameOptional


        if (rowIndex === 0) {
          if (config.isHeaderNameOptional && valueConfig.name === columnValue) {
            return;
          }

          if (!config.isHeaderNameOptional) {
            if (valueConfig.name !== columnValue) {
              file.inValidData.push({
                rowIndex: rowIndex + 1,
                columnIndex: columnIndex + 1,
                message: _isFunction(valueConfig.headerError) ? valueConfig.headerError(columnValue, valueConfig.name, rowIndex + 1, columnIndex + 1) : 'Header name ' + columnValue + ' is not correct or missing in the ' + (rowIndex + 1) + ' row / ' + (columnIndex + 1) + ' column. The Header name should be ' + valueConfig.name
              });
            }

            return;
          }
        }

        if (valueConfig.required && !columnValue.length) {
          file.inValidData.push({
            rowIndex: rowIndex + 1,
            columnIndex: columnIndex + 1,
            message: _isFunction(valueConfig.requiredError) ? valueConfig.requiredError(valueConfig.name, rowIndex + 1, columnIndex + 1) : String(valueConfig.name + ' is required in the ' + (rowIndex + 1) + ' row / ' + (columnIndex + 1) + ' column')
          });
        } else if (valueConfig.validate && !valueConfig.validate(columnValue)) {
          file.inValidData.push({
            rowIndex: rowIndex + 1,
            columnIndex: columnIndex + 1,
            message: _isFunction(valueConfig.validateError) ? valueConfig.validateError(valueConfig.name, rowIndex + 1, columnIndex + 1) : String(valueConfig.name + ' is not valid in the ' + (rowIndex + 1) + ' row / ' + (columnIndex + 1) + ' column')
          });
        } else if (valueConfig.dependentValidate && !valueConfig.dependentValidate(columnValue, _getClearRow(row))) {
          file.inValidData.push({
            rowIndex: rowIndex + 1,
            columnIndex: columnIndex + 1,
            message: _isFunction(valueConfig.validateError) ? valueConfig.validateError(valueConfig.name, rowIndex + 1, columnIndex + 1) : String(valueConfig.name + ' not passed dependent validation in the ' + (rowIndex + 1) + ' row / ' + (columnIndex + 1) + ' column')
          });
        }

        if (valueConfig.optional) {
          columnData[valueConfig.inputName] = columnValue;
        }

        if (valueConfig.isArray) {
          columnData[valueConfig.inputName] = columnValue.split(',').map(function (value) {
            return value.trim();
          });
        } else {
          columnData[valueConfig.inputName] = columnValue;
        }
      });

      if (Object.keys(columnData).length) {
        file.data.push(columnData);
      }
    });

    _checkUniqueFields(file, config);

    return file;
  }
  /**
   * @param {Object} file
   * @param {Object} config
   * @private
   */


  function _checkUniqueFields(file, config) {
    if (!file.data.length) {
      return;
    }

    config.headers.filter(function (header) {
      return header.unique;
    }).forEach(function (header) {
      if (!isValuesUnique(file.data, header.inputName)) {
        var duplicates = [];
        file.data.forEach(function (row, rowIndex) {
          var value = row[header.inputName];

          if (duplicates.indexOf(value) >= 0) {
            file.inValidData.push({
              rowIndex: rowIndex + 2,
              message: _isFunction(header.uniqueError) ? header.uniqueError(header.name, rowIndex + 2) : String("".concat(header.name, " is not unique at the ").concat(rowIndex + 2, " row"))
            });
          } else {
            duplicates.push(value);
          }
        });
      }
    });
  }
  /**
   * @param {Array<string>} row
   * @private
   * @return {Array}
   */


  function _getClearRow(row) {
    return row.map(function (columnValue) {
      return _clearValue(columnValue);
    });
  }
  /**
   * Remove BOM character
   * @param {String} value
   * @private
   * @return {String}
   */


  function _clearValue(value) {
    return value.replace(/^\ufeff/g, '');
  }

  return CSVFileValidator;
});